import { render, staticRenderFns } from "./AthleteSelfAssessmentStatCard.vue?vue&type=template&id=6b886822&scoped=true&"
import script from "./AthleteSelfAssessmentStatCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentStatCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentStatCard.vue?vue&type=style&index=0&id=6b886822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b886822",
  null
  
)

export default component.exports